import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./UserAlertHistory.css";
import homeIcon from "../images/home.png";
import profileIcon from "../images/account_circle.png";
import alertIcon from "../images/alerts-active.png";

const UserAlertHistory = () => {
  const [alerts, setAlerts] = useState([]);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData"));
    if (!user) return navigate("/login");

    fetch(`https://senu-app.azurewebsites.net/api/alerts/history/${user.id}`)
      .then((res) => {
        if (!res.ok) {
          return res.json().then((err) => {
            throw new Error(err.message || `HTTP ${res.status}`);
          });
        }
        return res.json();
      })
      .then((data) => setAlerts(data))
      .catch((err) => console.error("Error fetching user alerts:", err));
  }, [navigate]);

  return (
    <AnimatePresence>
      <motion.div
        key={location.pathname}
        className="user-alert-container"
        initial={{ x: "-100%", opacity: 0, scale: 0.95 }}
        animate={{ x: 0, opacity: 1, scale: 1 }}
        exit={{ x: "100%", opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.3 }}
      >
        {/* Top bar */}
        <div className="top-bar">
          <button className="back-button" onClick={() => navigate("/home")}>
            ← Back
          </button>
          <h2>My Alerts</h2>
        </div>

        {/* Alert list */}
        <div className="alerts-list">
          {alerts.length === 0 ? (
            <p>No alerts found.</p>
          ) : (
            alerts.map((alert) => (
              <div
                key={alert.id}
                className={`alert-item ${alert.status.toLowerCase()}`}
                onClick={() => setSelectedAlert(alert)}
              >
                <p>{alert.message} – {alert.location}</p>
                <span>{new Date(alert.timestamp).toLocaleString()}</span>
              </div>
            ))
          )}
        </div>

        {/* Bottom Nav (fixed) */}
        <nav className="bottom-nav">
          <Link to="/user-alert-history">
            <motion.img
              src={alertIcon}
              alt="Alert"
              className="nav-icon center-icon"
              layout
              animate={{
                scale: location.pathname === "/user-alert-history" ? 1 : 1,
                y: location.pathname === "/user-alert-history" ? -5 : 0,
              }}
              transition={{ type: "spring", stiffness: 400, damping: 25 }}
            />
          </Link>

          <Link to="/home">
            <motion.img
              src={homeIcon}
              alt="Home"
              className="home-icon"
              layout
              animate={{ scale: location.pathname === "/home" ? 1.2 : 1 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
            />
          </Link>

          <Link to="/edit-profile">
            <motion.img
              src={profileIcon}
              alt="Profile"
              className="nav-icon"
              animate={{
                scale: location.pathname === "/profile" ? 1.5 : 1,
                y: location.pathname === "/profile" ? -5 : 0,
              }}
              transition={{ type: "spring", stiffness: 400, damping: 25 }}
            />
          </Link>
        </nav>

        {/* MODAL */}
        {selectedAlert && (
          <div className="modal-overlay" onClick={() => setSelectedAlert(null)}>
            <div
              className="modal"
              onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
            >
              <h3>Alert Details</h3>
              <p><strong>Status:</strong> {selectedAlert.status}</p>
              <p><strong>Message:</strong> {selectedAlert.message}</p>
              <p><strong>Location:</strong> {selectedAlert.latitude},{selectedAlert.longitude}</p>
              <p>
                <strong>Time:</strong>{" "}
                {new Date(selectedAlert.timestamp).toLocaleString()}
              </p>

              {/* Google Map embed */}
              {selectedAlert.latitude && selectedAlert.longitude ? (
                <iframe
                  title="alert-map"
                  width="100%"
                  height="200"
                  style={{ borderRadius: "8px", marginTop: "10px" }}
                  src={`https://www.google.com/maps?q=${selectedAlert.latitude},${selectedAlert.longitude}&hl=es;z=14&output=embed`}
                ></iframe>
              ) : (
                <p style={{ color: "gray" }}>⚠️ No coordinates available</p>
              )}

              <button
                className="close-button"
                onClick={() => setSelectedAlert(null)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default UserAlertHistory;
